function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.816 6.9a.274.274 0 0 1 .366 0l6.088 5.86c.09.09.025.24-.106.24H.838c-.132 0-.2-.15-.106-.24zM0 5.013c0-.135.165-.213.277-.131l3.925 2.83a.366.366 0 0 1 .04.572L.255 12.074c-.091.094-.256.029-.256-.098zm13.723-.131c.112-.082.277-.004.277.13v6.967c0 .127-.16.188-.256.098L9.756 8.284a.371.371 0 0 1 .039-.572zm-3.62-.254c.25 0 .454.198.454.44a.45.45 0 0 1-.458.441H3.668a.448.448 0 0 1-.455-.44c0-.243.204-.44.455-.44h6.435zM10.9 0c.106 0 .207.04.288.109l1.758 1.556c.09.08.136.185.136.297l-.013 2.417-.623.446c-.05.036-.122.004-.122-.056l-.005-2.63-1.02-.016a.528.528 0 0 1-.526-.527V.732l-.009-.008H1.955a.48.48 0 0 0-.491.466l.004 3.583c0 .06-.068.096-.118.06l-.661-.454L.7 1.19C.701.535 1.265 0 1.955 0zm-.797 2.864c.25 0 .454.198.454.441 0 .247-.204.44-.458.44H3.668a.448.448 0 0 1-.455-.44c0-.243.204-.44.455-.44h6.435z"
});

var SvgOpenEnvelope = function SvgOpenEnvelope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOpenEnvelope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/open-envelope.bd313391.svg";
export { ForwardRef as ReactComponent };